module.exports = __webpack_public_path__ + "img/0 2.d5aff8d3.png";